import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import {featureInterface} from "../../../../interfaces/featureInterface";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import IconButton from "@mui/material/IconButton";

import {ROUTES} from "../../../../routes";
import WithShopFeatureVisualizeClick from "./withShopFeatureVisualizeClick";

const ShopFeatureBackNextButtons = (props) => {

  const {feature, history, intl, shopPageLeaved} = props;

  const backButtonClick = () => {
    history.push(`${ROUTES.shop}/${feature.partId}/`);
  }

  return (
    <div className="shop-navigate shop-navigate--feature">
      <IconButton aria-label={intl.formatMessage({id: "iconButton.back"})}
                  className="look-icon look-icon--small1 look-icon--gray shop-navigate__button"
                  onClick={backButtonClick}>
        <NavigateBeforeIcon/>
      </IconButton>
      {shopPageLeaved ? (
        <WithShopFeatureVisualizeClick feature={feature}>
          {(visualizeButtonClick) => (
            <IconButton aria-label={intl.formatMessage({id: "iconButton.next"})}
                        className="look-icon look-icon--small1 look-icon--gray shop-navigate__button"
                        onClick={visualizeButtonClick}>
              <NavigateNextIcon/>
            </IconButton>
          )}
        </WithShopFeatureVisualizeClick>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {shopPageLeaved} = store.shopState;
  return {
    shopPageLeaved
  };
};

const mapDispatchToProps = {

};

ShopFeatureBackNextButtons.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ShopFeatureBackNextButtons)
  )
)
